import { ENDPOINTS } from '@/constants/api'
import type { ResponseData } from '@/types/api'
import { apiSlice } from './base'

/** A permission grant on a role: `${resource}:${action}`. */
export type RolePermission = ResponseData<'/api/v1/permissions/roles/{roleId}', 'get'>[number]

export const permissionsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRolePermissions: builder.query<RolePermission[], string>({
      query: (roleId) => ENDPOINTS.PERMISSIONS.FOR_ROLE(roleId),
      transformResponse: (response: { data: RolePermission[] }) => response.data,
    }),

    /**
     * The caller's own permissions. Unlike getRolePermissions this needs no
     * `role:read` grant, so it resolves for every authenticated role.
     */
    getMyPermissions: builder.query<RolePermission[], void>({
      query: () => ENDPOINTS.PERMISSIONS.MINE,
      transformResponse: (response: { data: RolePermission[] }) => response.data,
    }),
  }),
  overrideExisting: false,
})

export const { useGetRolePermissionsQuery, useGetMyPermissionsQuery } = permissionsApi
